const getCredentialData = (loginData) => loginData.get('credentials');
const getLoginError = (loginData) => loginData.get('error');

export {getCredentialData, getLoginError}